import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46db8692"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "opportunities-main",
  ref: "sectionMain"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "align-items-start" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Voltar", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "buttons-group" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline d-md-inline" }, " Desfavoritar ", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-heart" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline d-md-inline" }, " Favoritar ", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "back-button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-share" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline d-md-inline" }, " Compartilhar ")
], -1))
const _hoisted_18 = { class: "opportunities-menu-container" }
const _hoisted_19 = { class: "opportunities-menu" }
const _hoisted_20 = { class: "d-flex flex-wrap justify-content-between align-items-center w-100" }
const _hoisted_21 = { class: "dropdown d-lg-none w-100" }
const _hoisted_22 = {
  class: "btn btn-secondary dropdown-toggle mobile-dropdown-item",
  type: "button",
  id: "mobileMenuDropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list" }, null, -1))
const _hoisted_24 = {
  class: "dropdown-menu",
  "aria-labelledby": "mobileMenuDropdown"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "summary-opportunities-submenu" }
const _hoisted_28 = {
  key: 0,
  class: "summary-opportunities-submenu-items"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "summary-opportunities-submenu-items"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 2,
  class: "summary-opportunities-submenu-items"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "summary-spacing" }
const _hoisted_36 = {
  key: 0,
  class: "summary-opportunities-component-container"
}
const _hoisted_37 = {
  key: 1,
  class: "summary-opportunities-component-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_loading = _resolveComponent("page-loading")!
  const _component_OpportunityHeader = _resolveComponent("OpportunityHeader")!
  const _component_ExecutiveSection = _resolveComponent("ExecutiveSection")!
  const _component_ViabilitySection = _resolveComponent("ViabilitySection")!
  const _component_ViabilityPhisicDataSection = _resolveComponent("ViabilityPhisicDataSection")!
  const _component_ConstructivePotentialSection = _resolveComponent("ConstructivePotentialSection")!
  const _component_FinancialAnalysisSection = _resolveComponent("FinancialAnalysisSection")!
  const _component_RealStateMarketSection = _resolveComponent("RealStateMarketSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_page_loading, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "opportunities-map",
            style: _normalizeStyle({
          backgroundImage: 'url(' + _ctx.completeOpportunityStore.thumb_detalhe + ')',
          backgroundSize: 'cover'
        })
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "back-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickBack && _ctx.handleClickBack(...args)))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "back-button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFavoriteClick && _ctx.handleFavoriteClick(...args)))
                }, [
                  (_ctx.isCardFavorited())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                ]),
                _hoisted_17
              ])
            ])
          ], 4),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedMenuItemText), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: menuItem.id,
                        class: _normalizeClass([
                    'dropdown-item',
                    { active: _ctx.selectedMenuItem === menuItem.id },
                    { 'disabled': menuItem.disabled }
                  ]),
                        onClick: ($event: any) => (_ctx.handleMenuItemClick(menuItem.id, menuItem.text))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(menuItem.text), 1)
                      ], 10, _hoisted_25))
                    }), 128))
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: menuItem.id,
                    class: _normalizeClass([[
                'summary-opportunities-menu-item',
                { active: _ctx.selectedMenuItem === menuItem.id },
                { 'disabled-item': menuItem.disabled },
              ], "d-none d-lg-block"]),
                    onClick: ($event: any) => (_ctx.handleMenuItemClick(menuItem.id))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["summary-opportunities-menu-item-content", [{ 'disabled-item': menuItem.disabled }]])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass([{'summary-opportunities-menu-item-text':!menuItem.disabled}, { 'disabled-item': menuItem.disabled }])
                      }, _toDisplayString(menuItem.text), 3),
                      _createElementVNode("i", {
                        class: _normalizeClass(['fas', { 'fa-chevron-down': _ctx.selectedMenuItem === menuItem.id, 'fa-chevron-right': _ctx.selectedMenuItem !== menuItem.id }])
                      }, null, 2)
                    ], 2)
                  ], 10, _hoisted_26))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.selectedMenuItem === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectSubmenuItems, (submenuItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: submenuItem.id,
                        class: _normalizeClass([
                { 'summary-opportunities-submenu-item': !submenuItem.disabled },
                { 'summary-opportunities-submenu-item-disabled': submenuItem.disabled },
                { active: submenuItem.active }
              ]),
                        onClick: ($event: any) => (_ctx.handleSubmenuItemClick(submenuItem.id))
                      }, _toDisplayString(submenuItem.text), 11, _hoisted_29))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedMenuItem === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demographicSubmenuItems, (demographicSubmenuItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: demographicSubmenuItem.id,
                        class: _normalizeClass(['summary-opportunities-submenu-item', { active: demographicSubmenuItem.active }]),
                        onClick: ($event: any) => (_ctx.handleDemographicSubmenuItemClick(demographicSubmenuItem.id))
                      }, _toDisplayString(demographicSubmenuItem.text), 11, _hoisted_31))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedMenuItem === 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realStateMarketSubmenuItems, (realStateMarketSubmenuItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: realStateMarketSubmenuItem.id,
                        class: _normalizeClass([
                { 'summary-opportunities-submenu-item': !realStateMarketSubmenuItem.disabled },
                { 'summary-opportunities-submenu-item-disabled': realStateMarketSubmenuItem.disabled },
                { active: realStateMarketSubmenuItem.active }
              ]),
                        onClick: ($event: any) => (_ctx.handleRealStateMarketSubmenuItemClick(realStateMarketSubmenuItem.id))
                      }, _toDisplayString(realStateMarketSubmenuItem.text), 11, _hoisted_33))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.selectedMenuItem == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_OpportunityHeader, {
                  title: _ctx.titleBreadcrumb,
                  subtitle: _ctx.subtitleBreadcrumb,
                  breadcrumbs: _ctx.breadcrumbItem,
                  tags: _ctx.completeOpportunityStore.tags,
                  vgv: _ctx.currentVGV,
                  roi: _ctx.currentROI,
                  opportunityRef: _ctx.opportunityRef,
                  "show-hr": true,
                  onOpportunityHeaderVisible: _ctx.handleVisibleSection
                }, null, 8, ["title", "subtitle", "breadcrumbs", "tags", "vgv", "roi", "opportunityRef", "onOpportunityHeaderVisible"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            (_ctx.selectedMenuItem == 1 && _ctx.isMounted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_ExecutiveSection, {
                    onSummaryExecutiveSectionVisible: _ctx.handleVisibleSection,
                    "show-hr": true,
                    "is-blocked-opportunity": !_ctx.completeOpportunityStore.liberado
                  }, null, 8, ["onSummaryExecutiveSectionVisible", "is-blocked-opportunity"]),
                  _createVNode(_component_ViabilitySection, {
                    onSummaryViabilitySectionVisible: _ctx.handleVisibleSection,
                    "show-hr": true,
                    "is-blocked-opportunity": !_ctx.completeOpportunityStore.liberado
                  }, null, 8, ["onSummaryViabilitySectionVisible", "is-blocked-opportunity"]),
                  _createVNode(_component_ViabilityPhisicDataSection, {
                    onSummaryViabilityPhisicSectionVisible: _ctx.handleVisibleSection,
                    "show-hr": true,
                    "is-blocked-opportunity": !_ctx.completeOpportunityStore.liberado
                  }, null, 8, ["onSummaryViabilityPhisicSectionVisible", "is-blocked-opportunity"]),
                  _createVNode(_component_ConstructivePotentialSection, {
                    onSummaryConstructivePotentialSectionVisible: _ctx.handleVisibleSection,
                    "show-hr": true,
                    "is-blocked-opportunity": !_ctx.completeOpportunityStore.liberado
                  }, null, 8, ["onSummaryConstructivePotentialSectionVisible", "is-blocked-opportunity"]),
                  _createVNode(_component_FinancialAnalysisSection, {
                    onSummaryFinancialAnalysisSectionVisible: _ctx.handleVisibleSection,
                    "show-hr": true,
                    "is-blocked-opportunity": !_ctx.completeOpportunityStore.liberado
                  }, null, 8, ["onSummaryFinancialAnalysisSectionVisible", "is-blocked-opportunity"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedMenuItem == 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_RealStateMarketSection, {
                    onRealStateMarketSectionVisible: _ctx.handleVisibleSection,
                    "show-hr": true,
                    "is-blocked-opportunity": false
                  }, null, 8, ["onRealStateMarketSectionVisible"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
  ], 512))
}